import { Controller } from "@hotwired/stimulus"

// A certificate rendered at its real size inside a card-sized box: the iframe
// keeps the page's own dimensions (a design measured in points) and is scaled
// down to whatever width the card has. Loading is deferred until the card is
// near the viewport, so a review page with thirty certificates on it does not
// open thirty renders at once.
export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this.resizeObserver = new ResizeObserver(() => this.scale())
    this.resizeObserver.observe(this.element)

    this.intersectionObserver = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) this.load()
    }, { rootMargin: "400px" })
    this.intersectionObserver.observe(this.element)

    this.scale()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
    this.intersectionObserver?.disconnect()
  }

  load() {
    if (!this.hasFrameTarget) return
    const frame = this.frameTarget
    if (frame.getAttribute("src")) return

    frame.addEventListener("load", () => this.element.classList.remove("is-loading"), { once: true })
    frame.setAttribute("src", frame.dataset.src)
    this.intersectionObserver.disconnect()
  }

  // Points to CSS pixels: 72pt to the inch, 96px to the inch.
  scale() {
    if (!this.hasFrameTarget) return
    const pageWidthPx = parseFloat(this.element.dataset.pageWidth) * (96 / 72)
    const scale = this.element.clientWidth / pageWidthPx
    if (Number.isFinite(scale) && scale > 0) this.frameTarget.style.transform = `scale(${scale})`
  }
}
